import React, { useRef } from 'react'
import CommonBanner from '../../components/common/CommonBanner'
import Banner from "../../Assets/Blog/BlogBanner.png";
import BlogCard from '../../components/User/Home/BlogCard';
import ScrollArrowButtons from '../../components/common/ScrollArrowButtons';
import LabelHeading from '../../components/common/LabelHeading';
import { assets } from '../../Assets/assets';
import blogs from "../../config/blog.json"

const MainBlog = () => {
  // console.log(blogs)
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -350, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 350, behavior: "smooth" });
  };

  const blogData = [
    { img: assets.blogimg1, profile: assets.profile, date: "25 Nov,2025", heading: "Hybrid Staffing & IT: A Smarter Approach" },
    { img: assets.blogimg2, profile: assets.profile2, date: "30 Nov,2025", heading: "Why 24/7 Support Matters the most - IT & Staffing" },
    { img: assets.blogimg3, profile: assets.profile3, date: "30 Dec,2025", heading: "Tech Trends Shaping Recruitment Process smartly" },
    { img: assets.blogimg4, profile: assets.profile4, date: "25 Nov,2025", heading: "Hybrid Staffing & IT: A Smarter Approach" },
    { img: assets.blogimg2, profile: assets.profile2, date: "30 Nov,2025", heading: "Why 24/7 Support Matters the most - IT & Staffing" },
    { img: assets.blogimg3, profile: assets.profile3, date: "30 Dec,2025", heading: "Tech Trends Shaping Recruitment Process smartly" },
  ];
  return (
    <div className='overflow-hidden'>
      <CommonBanner backgroundImage={Banner} title="Blogs" subheading="Home/Blogs" />

      <section className="w-full relative bg-[#ECF7FC]">
        <img src={assets.blogbg} alt="bannerbg" className="absolute inset-0 w-full h-full pointer-events-none opacity-25 z-0" />

        <div className="max-w-[1400px] mx-auto px-6 xl:py-16 py-14 relative z-10">

          <LabelHeading
            label={"Our Blogs"}
            heading={"Visit our Insights"}
            text={"A flexible workforce strategy where companies hire external professionals for specific projects or periods."}
          />

          <div className="space-y-4 mt-6">
            <div className="flex justify-end gap-2 items-center">
              <ScrollArrowButtons scrollLeft={scrollLeft} scrollRight={scrollRight} />
            </div>

            <div
              ref={scrollRef}
              className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6  pb-3"
            >
              {blogs?.slice(0, 4)?.map((item, index) => (
                <BlogCard key={index} title={item.title} profile={blogData[index].profile} img={blogData[index].img} date={item.date} id={item.id} />
              ))}
            </div>

          </div>
        </div>
      </section>
    </div>
  )
}

export default MainBlog